import { Log } from '@/types/logs'

export const checkIsMechanicalInfoMissing = (log: Log): boolean =>
    !!log?.unfinishedVersion?.codeTypeReasonInfo?.isMechanicalInfoRequired && !log?.unfinishedVersion?.mechanicalInfo

export const checkIsFixMechanicalInfoMissing = (log: Log): boolean =>
    !!log?.unfinishedVersion?.codeTypeReasonInfo?.isMechanicalInfoRequired &&
    !log?.unfinishedVersion?.mechanicalInfo &&
    !!log?.mechanicalInfo

export const checkIsOfficialReportMissing = (log: Log): boolean =>
    !!log?.unfinishedVersion?.codeTypeReasonInfo?.isOfficialReportRequired && !log?.unfinishedVersion?.report
export const checkIsFixOfficialReportMissing = (log: Log): boolean =>
    !!log?.unfinishedVersion?.codeTypeReasonInfo?.isOfficialReportRequired &&
    !log?.unfinishedVersion?.report &&
    !!log?.report

export const checkIsfRecordFlagged = (log: Log): boolean => !!log?.unfinishedVersion?.unfinishedFlagMetadata?.flag

export const checkIsRecordUnfinished = (log: Log): boolean =>
    !!log.unfinishedVersion || !!log.propertiesChanged?.length || !!log.missingFields?.length
